import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import authServices from '../services/authServices';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';

import TextControl from '../components/customizedInputs/TextControl';

const Ingreso = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation, showSideMenu, setShowSideMenu] = useContext(InputContext)
  const [datosUsuario, setDatosUsuario] = useState({usuario: "", password: ""});
  const [step, setStep] = useState(1);
  const [rolesParaElegir, setRolesParaElegir] = useState([]);

  useEffect(() => {
    if(authInformation.autenticado === true){
      navigate(`/`);
    }
  }, [authInformation]);

  const signIn = async (rol='') => {
    try {
      const data = await authServices.signIn({...datosUsuario, rol: rol});

      if(data.token){
        localStorage.setItem('token', data.token);

        setAuthInformation({
          token: data.token,
          nombre: data.nombre,
          usuario_id: data.usuario_id,
          rol: data.rol,
          usuario: data.usuario,
          autenticado: true,
          es_supervisor: data.es_supervisor,
        })

      } else {
        setAuthInformation({autenticado: false})
        localStorage.removeItem('token');
      }
    } catch (error) {
      if( error.response && error.response.status===401 && error.response.data && error.response.data.accion === 'rol_selection' ){
        setStep(2)
        setRolesParaElegir(error.response.data.roles)
      } else {
        errorMessage(error)
      }
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setDatosUsuario({...datosUsuario,
        [name]: value
    })
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()

    if (!datosUsuario.usuario || !datosUsuario.password) {
      alert('Por favor, ingrese su usuario y contraseña.');
      return;
    }
    signIn()
  }


  return (
    <div>
      {(authInformation.autenticado === false) && (
        <main >
          <form>
            <h1>Ingreso</h1>
            {/* <pre>{JSON.stringify(authInformation, null, 2)}</pre> */}
            {step === 1 && (
              <div className="w-100 m-auto" style={{maxWidth: '330px'}}>
                <TextControl
                  value={datosUsuario.usuario}
                  name={'usuario'}
                  handleInput={handleInput}
                  label='Usuario'
                  />

                <TextControl
                  value={datosUsuario.password}
                  name={'password'}
                  handleInput={handleInput}
                  type='password'
                  label='Clave'
                  />

                <Link className="btn btn-link mb-3" to="/recuperoClave">Olvidaste la clave ?</Link>

                <button className="btn btn-primary mt-3" onClick={handleFormSubmit} type="submit">Entrar</button>
              </div>
            )}

            {step === 2 && (
              <div className='w-50 m-auto'>
              <h3>Elija el rol</h3>
              <div className="row m-auto">
                {
                  rolesParaElegir.map((rol, idx) => (
                    <div key={idx} className="col-sm-6 d-grid">
                      <button
                        className="btn btn-primary bg-gradient py-5 mb-3 fs-3"
                        onClick={() => signIn(rol)}
                        type="button"
                        >{rol}</button>
                    </div>
                  ))
                }
              </div>
              </div>
            )}


          </form>
        </main>
      )}

    </div>
  );
};

export default Ingreso;